import React, { useState } from 'react'

const NewShareIcon2 = ({ color = '#fff', hoverColor = '#bbfa33' }) => {
  const [isHovered, setIsHovered] = useState(false)
  const handleMouseEnter = () => {
    setIsHovered(true)
  }
  const handleMouseLeave = () => {
    setIsHovered(false)
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.255"
      height="19.106"
      viewBox="0 0 16.255 19.106"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <g data-name="share-svgrepo-com (4)">
        <path
          data-name="Path 922"
          d="M8.752 11.876A2.376 2.376 0 1 1 6.376 9.5a2.376 2.376 0 0 1 2.376 2.376z"
          transform="translate(-3 -2.323)"
          style={{ fill: 'none', stroke: isHovered ? hoverColor : color, strokeWidth: 2 }}
        />
        <path
          data-name="Path 923"
          d="M13.752 6.5 9 9.826"
          transform="translate(-3.248 -2.174)"
          style={{
            strokeLinecap: 'round',
            fill: 'none',
            stroke: isHovered ? hoverColor : color,
            strokeWidth: 2,
          }}
        />
        <path
          data-name="Path 924"
          d="M13.752 17.326 9 14"
          transform="translate(-3.248 -2.546)"
          style={{
            strokeLinecap: 'round',
            fill: 'none',
            stroke: isHovered ? hoverColor : color,
            strokeWidth: 2,
          }}
        />
        <path
          data-name="Path 925"
          d="M18.752 18.376A2.376 2.376 0 1 1 16.376 16a2.376 2.376 0 0 1 2.376 2.376z"
          transform="translate(-3.497 -2.646)"
          style={{ fill: 'none', stroke: isHovered ? hoverColor : color, strokeWidth: 2 }}
        />
        <path
          data-name="Path 926"
          d="M18.752 5.376A2.376 2.376 0 1 1 16.376 3a2.376 2.376 0 0 1 2.376 2.376z"
          transform="translate(-3.497 -2)"
          style={{ fill: 'none', stroke: isHovered ? hoverColor : color, strokeWidth: 2 }}
        />
      </g>
    </svg>
  )
}

export default NewShareIcon2
